export default "__VITE_ASSET__d9e7f9c7__"